import { UserFull } from '@wellesley/openapi'
import getCleanUsername from 'helpers/getCleanUsername'

import { useGetApiV1UsersQuery } from '../userApi'

type HookProps = {
  username?: string
  canFetch?: boolean
  htmlContent?: boolean
}

export const useGetUserByUserName = ({
  username,
  canFetch = true,
  htmlContent = true,
}: HookProps) => {
  const cleanUsername = getCleanUsername(username)

  const { data, error, isLoading } = useGetApiV1UsersQuery(
    {
      username: cleanUsername,
      full: true,
      htmlContent,
    },
    {
      skip: !cleanUsername || !canFetch,
    },
  )

  return { data: data as UserFull, error, isLoading }
}

export default useGetUserByUserName
